import KdMarker from "../../assets/image/kd-marker.png";
import IconPaymentPaid from "../../assets/image/icons/payment-paid.png";
import IconPaymentUnpaid from "../../assets/image/icons/payment-unpaid.png";
import IconPaymentRefunded from "../../assets/image/icons/payment-refunded.png";

import ImageMemberStandard from "../../assets/image/reward/standard.jpg";
import ImageMemberSilver from "../../assets/image/reward/silver.jpg";
import ImageMemberGold from "../../assets/image/reward/gold.jpg";
import Console from "../../assets/image/icons/console.png";
import ShoppingBag from "../../assets/image/icons/shopping-bag.png";

import DefaultImg from "../../assets/image/image-default.jpg";

import PaymentCash from "../../assets/image/icons/payment-cash.png";
import PaymentTransfer from "../../assets/image/icons/payment_transfer.png";
import PaymentCreditCard from "../../assets/image/icons/payment_credit_card.png";
import PaymentPayoo from "../../assets/image/icons/payment-payoo.png";
import paymentPayooDomestic from "../../assets/image/icons/payment_payoo_domestic.svg";
import paymentPayooInternational from "../../assets/image/icons/payment_payoo_international.svg";
import paymentPayooInstallment from "../../assets/image/icons/payment_payoo_installment.svg";
import paymentPayooPayAtStore from "../../assets/image/icons/payment_payoo_pay_at_store.svg";
import paymentPayooQrcode from "../../assets/image/icons/payment_payoo_qrcode.svg";
import paymentPayooApp2app from "../../assets/image/icons/payment_payoo_app2app.svg";
import PaymentVnpay from "../../assets/image/icons/payment-vnpay.svg";
import PaymentMomo from "../../assets/image/icons/payment-momo.png";

import IconYoutube from "../../assets/image/icons/icon-youtube.svg";
import IconFaceBook from "../../assets/image/icons/icon-facebook.svg";
import IconTwister from "../../assets/image/icons/icon-twis.svg";

import Arrow from "../../assets/image/icons/arrow-no-tail.svg";
import IconArrow from "../../assets/image/icons/icon-arrow.svg";

import LoadingCheckMark from "../../assets/image/icons/loading-check-mark.gif";
import SadFace from "../../assets/image/icons/55171-sad-face.gif";
import LoadingPage from "../../assets/image/loading-page.gif";

const IconGOV =
  "https://kdstore.s3-ap-southeast-1.amazonaws.com/static/icons/logoSaleNoti.png";
const IconProductPromotion =
  "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/imgs/the-them-qua-tang_1.svg";
const IconProductSecialMattressPromotion =
  "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/the_them_qua_tang-pillow_top.svg";
const IconHotline =
  "https://kdstore.s3-ap-southeast-1.amazonaws.com/static/icons/icon-hotline.gif";
const IconTools =
  "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon%20___-64.svg";
const IconPhone =
  "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_phone-63.svg";
const IconChat =
  "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_mes-62.svg";
const IconShare =
  "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_Share-61.svg";
const IconClose =
  "https://kdstore.s3-ap-southeast-1.amazonaws.com/static/icons/close-icon-87.svg";

const PaymentIcons = {
  payment_cash: PaymentCash,
  payment_transfer: PaymentTransfer,
  payment_credit_card: PaymentCreditCard,
  payment_payoo: PaymentPayoo,
  payment_payoo_domestic: paymentPayooDomestic,
  payment_payoo_international: paymentPayooInternational,
  payment_payoo_installment: paymentPayooInstallment,
  payment_payoo_pay_at_store: paymentPayooPayAtStore,
  payment_payoo_qrcode: paymentPayooQrcode,
  payment_payoo_app2app: paymentPayooApp2app,
  payment_momo: PaymentMomo,
  payment_vnpay: PaymentVnpay,
};

export {
  PaymentIcons,
  KdMarker,
  IconPaymentPaid,
  IconPaymentUnpaid,
  IconPaymentRefunded,
  ImageMemberStandard,
  ImageMemberSilver,
  Console,
  ShoppingBag,
  ImageMemberGold,
  DefaultImg,
  IconFaceBook,
  IconTwister,
  IconYoutube,
  Arrow,
  LoadingCheckMark,
  SadFace,
  IconArrow,
  LoadingPage,
  IconGOV,
  IconProductPromotion,
  IconProductSecialMattressPromotion,
  IconHotline,
  IconTools,
  IconPhone,
  IconChat,
  IconShare,
  IconClose,
};
